var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSk = function SvgSk(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F0F0F0",
    d: "M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0052B4",
    d: "M12 24c6.627 0 12-5.373 12-12 0-1.468-.264-2.874-.746-4.174H.746A11.974 11.974 0 0 0 0 12c0 6.627 5.373 12 12 12Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D80027",
    d: "M12 24c5.16 0 9.558-3.257 11.253-7.826H.746C2.442 20.744 6.84 24 12 24Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F0F0F0",
    d: "M3.103 6.782v5.986c0 3.405 4.448 4.449 4.448 4.449s4.448-1.044 4.448-4.449V6.782H3.103Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D80027",
    d: "M4.146 6.782v5.986c0 .4.09.777.265 1.131h6.28a2.51 2.51 0 0 0 .265-1.13V6.781h-6.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F0F0F0",
    d: "M9.639 10.956H8.074V9.913h1.043V8.869H8.074V7.826H7.03v1.043H5.987v1.044H7.03v1.043H5.465V12H7.03v1.043h1.044V12h1.565v-1.044Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0052B4",
    d: "M5.834 15.357a7.494 7.494 0 0 0 1.717.777 7.49 7.49 0 0 0 1.717-.777c.678-.426 1.154-.913 1.424-1.456a1.817 1.817 0 0 0-1.469-.287 1.826 1.826 0 0 0-3.343 0 1.827 1.827 0 0 0-1.469.287c.27.543.745 1.03 1.423 1.456Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgSk;